import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { selectIsMobile } from 'src/common/selectors/app';
import CommonDialog from '../../dialog/CommonDialog';
import Popover from '../../Popover';

export default function FavoriteOptionSelector(props) {
  const {
    isOpen,
    onClose,
    children,
    popoverClassName,
    dialogBodyClassName,
    closeIconAttributes,
    dialogContentClassName,
  } = props;
  const isMobile = useSelector(selectIsMobile);

  return isMobile ? (
    <CommonDialog
      dialogOpen={isOpen}
      handleDialogClose={onClose}
      classNames={{
        body: dialogBodyClassName,
        content: dialogContentClassName,
      }}
      closeButtonProps={closeIconAttributes}
      data-testid="favoriteOptionSelectorDialog"
    >
      {children}
    </CommonDialog>
  ) : (
    <Popover isOpen={isOpen} className={popoverClassName}>
      {children}
    </Popover>
  );
}

FavoriteOptionSelector.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired,
  popoverClassName: PropTypes.string,
  dialogBodyClassName: PropTypes.string,
  closeIconAttributes: PropTypes.object,
  dialogContentClassName: PropTypes.string,
};
